/**
 * Inserts elements into an array if a condition is met otherwise returns an empty array.
 */
export const insertIf = <T>(condition: boolean, ...elements: T[]): T[] => {
  return condition ? elements : [];
};
